Pixlee.module('HorizontalApp', function(HorizontalApp, _App, _Backbone, _Marionette, _$) {
    HorizontalApp.on("start", function(options) {
        new HorizontalApp.Show.Controller(options);
    });
});
